import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ComponentsModule, DialogService, SnackBarService, TabItem } from '@mastechnicaegroup/carelinelive-ui';
import { AsyncPipe } from '@angular/common';
import { RefreshableResult } from '@mastechnicaegroup/carelinelive-cdk/rx';
import { RegionSingleResponse } from '@lib/api/models/region';
import { Priority } from '@lib/api/models/priorities';
import { PromptRegionPrioritiesStatusChangeDialogComponent } from '../../../../dialogs/prompt/priorities/prompt-region-priorities-status-change-dialog.component';
import { catchError, of, tap } from 'rxjs';
import { AuthenticationService } from '@lib/auth/authentication.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-region-priorities-tab',
    imports: [ComponentsModule, AsyncPipe],
    templateUrl: './region-priorities-tab.component.html',
    standalone: true,
    styleUrl: './region-priorities-tab.component.scss'
})
export class RegionPrioritiesTabComponent {
    @Input() regionData: RefreshableResult<RegionSingleResponse> | undefined;
    @Output() addPriorityEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() editPriorityEvent: EventEmitter<Priority> = new EventEmitter<Priority>();

    private readonly _snackBar = inject(SnackBarService);
    private readonly _dialog = inject(DialogService);
    private readonly _authService = inject(AuthenticationService);

    protected user = toSignal(this._authService.user$);

    protected readonly tabItems: TabItem[] = [
        {
            disabled: false,
            id: '1',
            title: 'All'
        },
        {
            disabled: false,
            id: '2',
            title: 'Active'
        },
        {
            disabled: false,
            id: '3',
            title: 'Inactive'
        }
    ];

    addPriority() {
        this.addPriorityEvent.emit();
    }

    editPriority(priority: Priority) {
        this.editPriorityEvent.emit(priority);
    }

    changeStatus(priority: Priority, status: boolean) {
        const priorityData = {
            ...priority,
            status: status
        };

        return PromptRegionPrioritiesStatusChangeDialogComponent.show(this._dialog, priorityData).closed.pipe(
            tap(() => {
                this.regionData?.refresh();
            }),
            catchError(() => {
                this._snackBar.open({
                    colour: 'error',
                    dismissable: false,
                    icon: 'error_outline',
                    title: 'Priority failed to change status',
                    actions: [
                        { id: 'undo', label: 'OK' }
                    ]
                });
                return of(null);
            })
        ).subscribe();
    }
}
